// extracted by mini-css-extract-plugin
export default {"disabled":"Form_disabled__2zlB0","form":"Form_form__9w-ne"};